import styled from '@emotion/styled';
import { Button, Divider, Table } from 'antd';
import { useEffect, useState } from 'react';
import { YELLOW } from '../../../shared/colors';

const Container = styled.div`
  th {
    background-color: ${YELLOW} !important;
    color: white !important;
    font-weight: bold; 
  }

  .style-row {
    font-family: Poppins-L;
    color: black;

    &:hover > td {
      background-color: #eee !important;
      cursor: pointer;
    }
  }

  > .picker {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    margin-bottom: 25px;
  }

  .form-control-lg {
    min-height: 36px;
    min-width: 240px;
    padding: 6px 10px;
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 20px;
    }

    > .picker {
      align-items: stretch;
      flex-direction: column;
    }

    .form-control-lg {
      min-width: 0;
      width: 100%;
    }
  }
`;

export const CourbesCemac = () => {
  const [reglements, setReglements] = useState<any[]>([]);
  const [filterReglements, setFilterReglements] = useState<any[]>([]);
  const [selectData, setSelectData] = useState('');

  useEffect(() => {
    setReglements(REGLEMENTS);
    setFilterReglements(REGLEMENTS);
  }, []);

  const filter = () => {
    
    if (selectData) {
      setFilterReglements(
        reglements.filter((ac) => {
          console.log(selectData, reglements, ac.titre.includes(selectData));
          if (ac.titre.includes(selectData) > -1) {
            return true;
          }
          return false;
        }),
      );
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSelectData(value);
  };
  const COLUMNS = [
    {
      title: 'Titre du document',
      dataIndex: 'title',
      render: (cell: any, row: any) => (
        <span onClick={() => window.open(row.lien, '_blank')}>{cell}</span>
      ),
      width: 1300,
    },
    {
      title: 'Taille',
      dataIndex: 'taille',
      width: 200,
    },
    {
      title: 'Pays',
      dataIndex: 'pays',
      width: 200,
    },
    {
      title: 'Année',
      dataIndex: 'annee',
      width: 200,
    },
    
  ];

  return (
    <Container>
      <h2>COURBES DE TAUX PAR REGION</h2>
      <Divider style={{ backgroundColor: 'orange', marginBottom: 10 }} />
      <div className='picker'>
      <input
              className="form-control-lg"
              placeholder="Rechercher"
              type="text"
              onChange={handleInput}
            />
        <Button className='butt' onClick={filter}>
          Valider
        </Button>
      </div>

      <div></div>
      <Table
        columns={COLUMNS}
        dataSource={filterReglements}
        rowClassName={(row, index) => 'style-row'}
        scroll={{ x: 900 }}
        size='small'
        style={{ zoom: 1 }}
        // pagination={false}
      />
    </Container>
  );
};


const REGLEMENTS = [
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Courbes-Cemac-septembre-2023.pdf", title:"Courbes de rendement des titres publics de la CEMAC - septembre 2023",
    taille: "170 KB",
    pays: " CEMAC",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/08/Courbe-CEMAC_juil-2023.pdf", title:"Courbe de rendements des titres publics de la CEMAC - juillet 2023",
    taille: "350 KB",
    pays: " CEMAC",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/07/Courbe-CEMAC_juin-2023.pdf", title:"Courbe de rendements des titres publics de la CEMAC - juin 2023",
    taille: "421 KB",
    pays: " CEMAC",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2023/05/Courbe-CEMAC_avril-2023.pdf", title:"Courbe de rendements des titres publics de la CEMAC - avril 2023",
    taille: "206 KB",
    pays: " CEMAC",
    annee: " 2023",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Donnees_CBT_Camerour-Gabon_aout_2017-3.xlsx", title:"CBT Août 2017 Cameroun et Gabon",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Données-CBT-CAM_GBN-juin-2017.xlsx", title:"CBT juin 2017 Cameroun et Gabon",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Données-CBT_CMR_GAB_mai-2017.xlsx", title:"CBT mai 2017 Cameroun et Gabon",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Données-CBT_CMR_GAB_avril-2017.xlsx", title:"CBT avril 2017 Cameroun et Gabon",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Données-CBT-Pr-Site-WEB-mars-2017-.xlsx", title:"CBT mars 2017 Cameroun et Gabon",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT-CMR-GA-TDfévrier-2017-_1.xlsx", title:"CBT Cameroun, Gabon et Tchad février 2017",
    taille: "28 KB",
    pays: " CEMAC",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/CBT-Cameroun_Gabon-Tchad_-janvier-2017.xlsx", title:"CBT Cameroun, Gabon et Tchad janvier 2017",
    taille: "28 KB",
    pays: " CEMAC",
    annee: " 2017",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Donnees_CBT_novembre_2016.xlsx", title:"CBT Cameroun et Gabon novembre 2016",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Données_CBT_septembre_2016_.xlsx", title:"CBT Cameroun et Gabon Septembre 2016",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2016",
  },
  {
    lien: "https://www.beac.int/wp-content/uploads/2016/10/Données_CBT_octobre-2016.xlsx", title:"CBT Cameroun et Gabon Octobre 2016",
    taille: "23 KB",
    pays: " CEMAC",
    annee: " 2016",
  },  
];
